import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { BrandColors } from '../../constants';

interface CommonStylesProps {
  contentContainerColor?: string;
  backButtonEnabled?: boolean;
}

export const commonStyles = makeStyles((theme: Theme) =>
  createStyles({
    bottomShadow: (props: CommonStylesProps) => ({
      position: 'relative',
      '&::before': {
        content: '""',
        height: '60px',
        width: '100%',
        position: 'absolute',
        left: '0rem',
        bottom: '0rem',
        background: `linear-gradient(180deg, ${BrandColors.scoreCardBg}  0%, 
          ${props.contentContainerColor || theme.palette.background.paper} 68.33%)`,
        borderRadius: '0 0 0.3125rem 0.3125rem',
        zIndex: 1,
      },
    }),
  }),
);
